'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './template-edit.routes';

export class TemplateEditComponent {
  constructor(Auth, $state, $stateParams, dialogs, TemplateService, Upload, StorageService) {
    'ngInject';

    this.templateId = $stateParams.id;

    this.dialogs = dialogs;
    this.TemplateService = TemplateService;
    this.Auth = Auth;
    this.Upload = Upload;
    this.StorageService = StorageService;

    this.jsonValue = "";
    this.$state = $state;

    this.schema = {
      type: "object",
      properties: {
        name: {
          type: "string",
          minLength: 3,
          title: "Name"
        },
        description: {
          type: "string",
          title: 'Description'
        }
      }
    };

    this.form = [
      "*"
    ];

    this.model = {
    };

    if (this.templateId) {
      this.TemplateService.get({id: this.templateId}, data => {
        this.model = data;

        this.StorageService.getMeta({id: data.template}, meta => {
          this.templateMeta = meta;
          console.log(this.templateMeta);
        })
      }, err => {
        console.log('Could not load template data from server');
      })
    }
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        var actionString = (this.templateId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "The template has been "+actionString+" successfully");
        dlg.result.then(() => {
          that.$state.go("template-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      if (this.replaceTemplateFile && this.templateFile) {
        this.Upload.upload({
          url: '/api/storage',
          data: {
            name: this.templateFile.name,
            file: this.templateFile,
            storageStrategy: 'local',
            creationUser: this.Auth.getCurrentUserSync()._id,
            active: true
          }
        }).then(
          (res) => {

            this.model.template = res.data;
            this.TemplateService.update({id: this.templateId}, this.model, onSuccess, onError);

          },
          (err) => {
            this.sendFailure = true;
          });
      } else {
        this.TemplateService.update({id: this.templateId}, this.model, onSuccess, onError);
      }
    }
  }
}

export default angular.module('conduu.templateEdit', [uiRouter])
  .config(routes)
  .component('templateEdit', {
    template: require('./template-edit.html'),
    controller: TemplateEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/template/template-edit/template-edit.component.js